import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";

class CategoryV1 extends Component {
  render() {
    const { category, lang, loading, pageConfig } = this.props.appData;
    const productTitleConfig =
      pageConfig?.product?.settings?.translations?.[lang].productsTitle ||
      "Ürünler";
    // null-safe dizi
    const categories = Array.isArray(category?.categories)
      ? category.categories
      : [];

    return (
      <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-90 go-top">
        {!loading && category && (
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title-area ltn__section-title-2--- text-center">
                  <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                    {productTitleConfig}
                  </h6>
                  <h1 className="section-title">
                    {lang === "tr" ? "Kategoriler" : "Categories"}
                  </h1>
                </div>
              </div>
            </div>
            <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center">
              {categories.map((cat, i) => {
                const t = cat.translations?.[lang] || {};
                const imgSrc = cat?.cover
                  ? fileUrl(API_FILE_URL, cat.cover)
                  : "";
                return (
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6" key={i}>
                    <div className="ltn__category-item ltn__category-item-5 text-center">
                      <Link
                        to={{
                          pathname: "/urunler",
                          state: { categoryId: cat.id },
                        }}
                      >
                        <img src={imgSrc} alt={t?.name || "Kategori resmi"} />
                        <span className="category-title">{t?.name || ""}</span>
                        <span className="category-btn">
                          <i className="flaticon-right-arrow" />
                        </span>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withAppData(CategoryV1);
